export default __webpack_public_path__ + "static/media/play-button.c5ed7368.svg";